import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <img src="/smrxashop-logo.png" alt="Šmrxa Shop" className="footer-logo-image" />
          <p className="footer-copyright">
            © Šmrxa Shop {currentYear}. Všechna práva vyhrazena.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

